import React from 'react';

import Header from './partials/header/Header';
import Service from './partials/service/Service';
import LoginForm from './partials/login-form/LoginForm';
import Footer from './partials/footer/Footer';

import * as css from './css/login';

function Login() {
  return (
    <css.Login>
      <css.BgImg src={require('./img/bg.png')} />
      <css.Header as={Header} />
      <css.Content>
        <css.Service as={Service} />
        <css.LoginForm as={LoginForm} />
      </css.Content>
      <css.Footer as={Footer} />
    </css.Login>
  );
}

export default Login;
